var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobs"},[_c('Header',{attrs:{"search":"true"}}),_vm._v(" "),_c('Cards'),_vm._v(" "),_c('infinite-loading',{attrs:{"identifier":_vm.infiniteId},on:{"infinite":_vm.infiniteItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }